export default __webpack_public_path__ + "static/media/bg-stream-a-2.f17e65dc.png";